// PreviewAbout.jsx
import { EnvironmentOutlined, GiftOutlined } from "@ant-design/icons"
import { Card, Col, Row, Tag } from "antd"
import PhotoSlider from "components/common/PhotoSlider"
import PropTypes from "prop-types"
import Alcohol from "../../../../../assets/icons/Alcohol.svg"
import BottledWater from "../../../../../assets/icons/BottledWater.svg"
import Cooler from "../../../../../assets/icons/Cooler.svg"
import Hopefully from "../../../../../assets/icons/Hopefully.svg"
import Sunglasses from "../../../../../assets/icons/Sunglasses.svg"
import Sunscreen from "../../../../../assets/icons/Sunscreen.svg"
import Ice from "../../../../../assets/icons/Vector.svg"
import FishingPoles from "../../../../../assets/icons/fishing_pole.svg"
import Tackle from "../../../../../assets/icons/tackle.svg"

import IconCard from "../IconCard"
export const PreviewAbout = ({ trip, t }) => {
  const { description, alcohol_allowed, accessibility_enabled, bring_items, included_items, skill_levels, children_allowed, boats } = trip
  const renderCardSection = (title, items) => (
    <div className="mt-40">
        <h2 className="h3" style={{ color: "#272A34", paddingBottom: "16px" }}>
        {title}
      </h2>
      <Row gutter={[16, 16]}>
        {items.map((item) => {
          const { label, icon } = getItemDetails(item)
          return (
            <Col xs={24} sm={12} key={item}>
              <IconCard icon={icon} label={label} />
            </Col>
          )
        })}
      </Row>
    </div>
  )

  const renderRecommendedCardSection = (title, items) => {
    return (
      items?.length > 0 &&
      <div className="mt-45">
        <h2 className="h3">{title}</h2>
        <Row gutter={[16, 16]}>
          {items?.map((item) => {
            const { label, icon } = getItemDetailsSkillLevel(item)
            return (
              <Col xs={24} sm={12} key={item}>
                <IconCard icon={icon} label={label} />
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }

  const renderNotAllowedCardSection = (title, items) => (
    <div className="mt-45">
      <h2 className="h3 pb-4">{title}</h2>
      <Row gutter={[16, 16]}>
        {Array.isArray(items) ? (
          items.map((item) => {
            const { label, icon } = getNotAllowedDetails(item)
            return (
              <Col xs={24} sm={12} key={item}>
                <IconCard icon={icon} label={label} />
              </Col>
            )
          })
        ) : (
          <Col xs={24} sm={12}>
            <IconCard icon={<img src={Alcohol} alt="alcohol" />} label={items} />
          </Col>
        )}
      </Row>
    </div>
  )

  const getNotAllowedDetails = (item) => {
    if (item === "alcohol") {
      return {
        label: "Alcohol is not allowed",
        icon: <img src={Alcohol} alt="alcohol" />
      }
    }
  }

  const getItemDetailsSkillLevel = (item) => {
    switch (item) {
      case "beginner":
        return { label: "Beginner", icon: <GiftOutlined /> }
      case "intermediate":
        return { label: "Intermediate", icon: <GiftOutlined /> }
      case "advanced":
        return { label: "Advanced", icon: <GiftOutlined /> }
      case "professional":
        return { label: "Professional", icon: <GiftOutlined /> }
      default:
        return { label: item, icon: <GiftOutlined /> }
    }
  }

  const getItemDetails = (item) => {
    switch (item) {
      case "fishing_lure":
        return { label: "Fishing lure", icon: <GiftOutlined /> }
      case "tackle":
        return { label: "Tackle", icon: <img src={Tackle} alt="tackle" /> }
      case "insect_repellent":
        return { label: "Insect repellent", icon: <GiftOutlined /> }
      case "waterproof_bag":
        return { label: "Waterproof bag", icon: <GiftOutlined /> }
      case "some_luck":
        return { label: "Hopefully some luck:)", icon: <img src={Hopefully} alt='some_luck' /> }
      case "life_jackets":
        return { label: "Life jackets", icon: <GiftOutlined /> }
      case "first_aid_kit":
        return { label: "First aid kit", icon: <GiftOutlined /> }
      case "snorkel_mask":
        return { label: "Snorkel mask", icon: <GiftOutlined /> }
      case "fishing_poles":
        return { label: "Fishing poles", icon: <img src={FishingPoles} alt="fishing_poles" /> }
      case "sinkers":
        return { label: "Sinkers", icon: <GiftOutlined /> }
      case "hooks":
        return { label: "Hooks", icon: <GiftOutlined /> }
      case "water_shoes":
        return { label: "Water shoes", icon: <GiftOutlined /> }
      case "towels":
        return { label: "Towels", icon: <GiftOutlined /> }
      case "swimwear":
        return { label: "Swimwear", icon: <GiftOutlined /> }
      case "sunscreen":
        return { label: "Sunscreen", icon: <img src={Sunscreen} alt='sunscreen' /> }
      case "sunglasses":
        return { label: "Sunglasses", icon: <img src={Sunglasses} alt="sun_glasses" /> }
      case "ice":
        return { label: "Ice", icon: <img src={Ice} alt="ice" /> }
      case "cooler":
        return { label: "Cooler", icon: <img src={Cooler} alt="cooler" /> }
      case "bottled_water":
        return { label: "Bottled water", icon: <img src={BottledWater} alt="bottled_water" /> }
      case "snacks":
        return { label: "Snacks", icon: <GiftOutlined /> }
      case "lunch":
        return { label: "Lunch", icon: <GiftOutlined /> }
      default:
        return { label: item, icon: <GiftOutlined /> } // <-- Add this fallback
    }
  }

  const items = []
  if (accessibility_enabled) items.push("Wheelchair accessible")
  if (children_allowed) items.push("Child friendly")
  if (alcohol_allowed) items.push("Alcohol allowed")
  const renderOtherCardSection = (title, items) => (
    <div className="mt-45">
      <h2 className="h3">{title}</h2>
      <Row gutter={[16, 16]}>
        {items.map((item) => {
          const { label, icon } = getOtherDetails(item) // Get label and icon
          return (
            <Col xs={24} sm={12} key={item}>
              <IconCard icon={icon} label={label} />
            </Col>
          )
        })}
      </Row>
    </div>
  )
  const getOtherDetails = (item) => {
    switch (item) {
      case "Wheelchair accessible":
        return { label: "Wheelchair accessible", icon: <GiftOutlined /> }
      case "Child friendly":
        return { label: "Child friendly", icon: <EnvironmentOutlined /> }
        case "Alcohol allowed":
        return { label: "Alcohol allowed", icon: <img src={Alcohol} alt="alcohol" /> }
    }
  }

  return (
    <>
      {/* About Section */}
      <div className="mt-40">
        <h3 className="h3" style={{ color: "#272A34", paddingBottom: "16px" }}>
          {t("global.about")}
        </h3>
        <p className="text-prewrap">{description}</p>
      </div>

      {/* What’s Included Section */}
      {included_items?.length > 0 && renderCardSection(t("trip.labels.included_items"), included_items)}

      {/* What to Bring Section */}
      {bring_items?.length > 0 && renderCardSection(t("trip.labels.bring_items"), bring_items)}

      {/* Not Allowed to Bring Section */}
      {!alcohol_allowed && renderNotAllowedCardSection(t("trip.labels.not_allowed_to_bring_items"), ["alcohol"])}

      {/* Recommended for Skill Levels Section */}
      {renderRecommendedCardSection(t("trip.labels.recommended_skills"), skill_levels)}

      {/* Other Section */}
      {items.length > 0 && renderOtherCardSection(t("trip.labels.other"), items)}

      {/* Equipment Section */}

      {boats?.length > 0 && <div className="mt-45">
        <h2 className="h3">{t("trip.labels.equipment")}</h2>
        {boats?.map((item) => {
          const characteristics = item.characteristics || []

          return (
            <Card key={item.id} style={{ borderRadius: "8px", marginBottom: "20px" }}>
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} sm={6}>
                  <PhotoSlider photos={item.properties} cropped_photos={item.cropped_photos} preview />
                </Col>

                <Col xs={24} sm={16} style={{ marginLeft: "20px" }}>
                  <h3>{item.name || item.equipment_title}</h3>
                  <p style={{ display: "-webkit-box", WebkitLineClamp: 4, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                    {item.description}
                  </p>
                  <div>
                    {characteristics.map((char) => (
                      <Tag key={char.id} color="blue" style={{ marginBottom: "8px" }}>
                        {char.name}
                      </Tag>
                    ))}
                  </div>
                </Col>
              </Row>
            </Card>
          )
        })}
      </div>}

    </>
  )
}
PreviewAbout.propTypes = {
  trip: PropTypes.shape({
    description: PropTypes.string,
    alcohol_allowed: PropTypes.bool,
    accessibility_enabled: PropTypes.bool,
    bring_items: PropTypes.arrayOf(PropTypes.string),
    included_items: PropTypes.arrayOf(PropTypes.string).isRequired,
    skill_levels: PropTypes.arrayOf(PropTypes.string),
    children_allowed: PropTypes.bool,
    media: PropTypes.array,
    boats: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
        description: PropTypes.string,
        properties: PropTypes.array, // Assuming this is image/media data for PhotoSlider
        custom_info: PropTypes.arrayOf(PropTypes.string) // Tags
      })
    )
  }).isRequired,
  t: PropTypes.func.isRequired
}

export default PreviewAbout
